export enum SystemSetting {
    DefaultLanguageId = 1
}
